








































































import { EventInfoModel } from '@/models/EventFormModel';
import { Form } from '@/models/FormModel';
import Vue from 'vue';

export default Vue.extend({
  components: {
  },
  data() {
    return {
      overEventTime: false,
      overRegistrationTime: false,
    };
  },
  computed: {
    eventInfo(): EventInfoModel {
      return this.$store.state.eventInfo;
    },
    form(): Form {
      return this.$store.state.form;
    },
    eventDate(): string {
      const { eventStartDate, eventEndDate } = this.eventInfo;
      return `${this.formatDateTime(eventStartDate)} ~ ${this.formatDateTime(eventEndDate)}`;
    },
    registrationDate(): string {
      const { registrationStartDate, registrationEndDate } = this.eventInfo;
      return `${this.formatDateTime(registrationStartDate)} ~ ${this.formatDateTime(registrationEndDate)}`;
    },
  },
  watch: {
    eventInfo() {
      this.init();
    },
    form() {
      this.init();
    },
  },
  methods: {
    init() {
      const eventTimestamp = Date.parse(this.eventInfo.eventEndDate);
      const registrationTimestamp = Date.parse(this.eventInfo.registrationEndDate);

      const currentTimestamp = Date.now();
      if (eventTimestamp < currentTimestamp) {
        this.overEventTime = true;
      }
      if (registrationTimestamp < currentTimestamp) {
        this.overRegistrationTime = true;
      }
    },
    formatDateTime(datetimeString: string): string {
      const date = new Date(datetimeString);
      const hour = date.getHours();
      const minute = date.getMinutes();
      return `${date.toLocaleDateString('zh-TW')} ${hour}:${minute}`;
    },
  },
});
